import { Directive, HostListener, Input, Renderer2, ElementRef, OnInit } from "@angular/core";
import { StateService } from "../../services/state.service";
import { S25States } from "../../services/state/state.map";
import { S25Util } from "../../util/s25-util";
import { Timeout } from "../../decorators/timeout.decorator";
import { S25Const } from "../../util/s25-const";

@Directive({
    selector: "[s25-ng-router-link]",
    standalone: true,
})

// Use this to bridge the gap between Angular and AngJs state management
export class S25RouterLinkDirective implements OnInit {
    @Input() stateName: S25States.Name | S25States.Key;
    @Input() stateParams: { viz: string; subject: string; search: string }; //This type is likely incomplete
    @Input() options?: { source: string; search?: string; forceParamChange?: boolean }; //This type is likely incomplete

    //This router should bind the passed in value for stateName to href attribute.
    // However, I want to intercept the behavior to call STateService.go so angularjs stays state aware on navigation
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
    ) {}

    @Timeout
    @HostListener("click", ["$event"])
    async onClick(event: MouseEvent) {
        if (event.ctrlKey) return; // Allow ctrl+click to open in new tab
        event.preventDefault();
        const [rslt, err] = await S25Util.Maybe(
            StateService.go(String(this.stateName), this.stateParams, this.options, false),
        );
        if (err) {
            console.error("Error navigating to state:", err);
            return;
        }
        if (rslt) {
            // Prevent default action if navigation was successful
            event.stopPropagation();
        }
    }

    createHref() {
        const state = S25States.untyped[<S25States.Key>this.stateName];
        let href: string = String(state?.url || this.stateName);

        if (this.stateParams) {
            Object.keys(this.stateParams).forEach((key: keyof typeof this.stateParams) => {
                href = href.replace(`:${key}`, this.stateParams[key]);
            });
        }
        return `${S25Const.baseUrl}#!/${state.parent}${href}`;
    }

    ngOnInit() {
        this.renderer.setAttribute(this.el.nativeElement, "href", this.createHref());
    }
}
